"use strict";

function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _propTypes = require("prop-types");
var Icons = _interopRequireWildcard(require("@olxbr/ds-icons"));
var _style = require("../style");
var _jsxRuntime = require("react/jsx-runtime");
function _getRequireWildcardCache(e) {
  if ("function" != typeof WeakMap) return null;
  var r = new WeakMap(),
    t = new WeakMap();
  return (_getRequireWildcardCache = function _getRequireWildcardCache(e) {
    return e ? t : r;
  })(e);
}
function _interopRequireWildcard(e, r) {
  if (!r && e && e.__esModule) return e;
  if (null === e || "object" != _typeof(e) && "function" != typeof e) return {
    "default": e
  };
  var t = _getRequireWildcardCache(r);
  if (t && t.has(e)) return t.get(e);
  var n = {
      __proto__: null
    },
    a = Object.defineProperty && Object.getOwnPropertyDescriptor;
  for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) {
    var i = a ? Object.getOwnPropertyDescriptor(e, u) : null;
    i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u];
  }
  return n["default"] = e, t && t.set(e, n), n;
}
var GetIconComponent = function GetIconComponent(iconName, iconAction) {
  var IconComponent = Icons[iconName];
  if (IconComponent) {
    return iconAction ? /*#__PURE__*/(0, _jsxRuntime.jsx)(_style.BgIcon, {
      children: /*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, {
        size: "25",
        color: "var(--color-secondary-110)"
      })
    }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(IconComponent, {
      size: "26"
    });
  }
  return null;
};
GetIconComponent.propTypes = {
  iconName: _propTypes.string.isRequired
};
var _default = exports["default"] = GetIconComponent;